import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { UserInvitation } from '../models/clientLocation';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  titleBarText : string;
  postLoginRedirect : string;
  hasRedirect : boolean;
  loggedInUserRoles : Array<string>;
  roleFetchComplete : Subject<any> = new Subject<any>()
  constructor(private http : HttpClient,private location : Router, private activatedRoute: ActivatedRoute, ) { 
  }

  UserInRole(role:string): boolean
  {
    if(!this.loggedInUserRoles)return false;
    return this.loggedInUserRoles.filter(r => {return r == role}).length > 0;
  }

  CheckUserName(name : string) {
    return this.http.get(environment.baseURl + `/api/userinvite/un/${name}`);
  }

  CheckPassword(pw: string) {
    var payload = { pwToCheck: pw };
    return this.http.post(environment.baseURl + '/api/userinvite/password/test/', payload);
  }


  GetToken(username:string, password:string) : Observable<Object>{
    return this.http.post(environment.baseURl + `/token`, {username, password});
  }

  ChangePassword(model: any) : Observable<Object>{
    return this.http.post(environment.baseURl + `/api/auth/password/change`, model);
  }

  CreateUserInvite(dta : UserInvitation){
    return this.http.post(environment.baseURl + `/api/auth/user/invite`, dta);
  }

  GetUsersRoles(){
    if(!this.loggedInUserRoles){
      this.http.get(environment.baseURl + '/api/auth/roles').subscribe(
        (s: any)=>{
          this.loggedInUserRoles = s;
          this.roleFetchComplete.next(true);
        }, 
        (err: any)=>{
          console.log(err);
          // TODO : handle this better. if its a 401 w make them log in. else let them know its an error.
          this.roleFetchComplete.next(err);
        })
    }else{
      this.roleFetchComplete.next(true);
    }
  }

  logout(){
    this.loggedInUserRoles = undefined;
    this.location.navigateByUrl("/auth")
  }
}
